import React, { useState, useEffect, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate, useLocation } from 'react-router-dom';

import Style from '../Styles/DashboardStyle.module.css';
import DashboardTitle from "./DashboardTitle";
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import { getCountryStateListFormData, getCategoryListFormData, createBusinessData,updateBusinessData, getCountryListFormData, getCityListByStateId,getStateListByCountryId} from "../../services/routes.services";
import FileUpload from "./FormField/FileUpload";
import TextInput from "./FormField/TextInput";
import SelectInput from "./FormField/SelectInput";
import { useSelector } from 'react-redux';
import constants from "../../services/constants";
const BusinessDirectoryCreate = () => {
    const location = useLocation();
    const Busnisslist = location.state?.Busnisslist || {};
    const fileUploadRef = useRef(null);
    const [avatarURL, setAvatarURL] = useState(Busnisslist.image?constants.IMAGE_BASE_URL+'/business/'+Busnisslist.image: "https://mayoalumni.in/images/upload-img-icon.png");
    const [companyName, setCompanyName] = useState(Busnisslist.name || "");
    const [websiteName, setWebsiteName] = useState(Busnisslist.link || "");
    const [companyEmail, setCompanyEmail] = useState(Busnisslist.email || "");
    const [companyContactName, setCompanyContactName] = useState(Busnisslist.username || "");
    const [selectedCountryCode, setSelectedCountryCode] = useState("+91");
    const [companyContactNumber, setCompanyContactNumber] = useState(Busnisslist.phone || "");
    const [companyPersonDesignaton, setCompanyPersonDesignaton] = useState(Busnisslist.designation || "");
    const [comapnyDescription, setComapnyDescription] = useState(Busnisslist.description || "");
    const [selectedCategory, setSelectedCategory] = useState(Busnisslist.categoryId && Busnisslist.categoryId._id || "");
    const [selectedCountryId, setSelectedCountryId] = useState(Busnisslist.country && Busnisslist.country._id || null);
    const [selectedCountryIdFilterValue, setSelectedCountryIdFilterValue] = useState(null);
    const [selectedStateIdFilterValue, setSelectedStateIdFilterValue] = useState(null);
    const [selectedStateId, setSelectedStateId] = useState(Busnisslist.state && Busnisslist.state._id || null);
    const [selectedCityId, setSelectedCityId] = useState(Busnisslist.city && Busnisslist.city._id || null);
    const [getAllData, setGetAllData] = useState(null);
    const [getAllCategory, setGetAllCategory] = useState(null);
    const [formErrors, setFormErrors] = useState({});
    const { isAuthenticated, user, token } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    useEffect(() => {
        getCountryListFormData()
            .then((res) => {
                setGetAllData(res.data);
            })
            .catch((error) => {
                console.log(error);
            });

            if(Busnisslist.country && Busnisslist.country._id){
                getStateListByCountryId(Busnisslist.country.id)
                .then((res) => {
                    setSelectedCountryIdFilterValue(res.data);
                })
                .catch((error) => {
                    console.log(error);
                });
            }
            if(Busnisslist.state && Busnisslist.state._id){
                getCityListByStateId(Busnisslist.state.id)
                .then((res) => {
                    setSelectedStateIdFilterValue(res.data);
                })
                .catch((error) => {
                    console.log(error);
                });
            }
        getCategoryListFormData()
            .then((res) => {
                setGetAllCategory(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [Busnisslist.country,Busnisslist.state]);

    const handleCountryChange = (e) => {
        setSelectedStateIdFilterValue(Busnisslist.state && Busnisslist.state._id || null)
        setSelectedStateId(null);
        const selectedOption = e.target.options[e.target.selectedIndex];
        getStateListByCountryId(selectedOption.id)
            .then((res) => {
                setSelectedCountryIdFilterValue(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
        setSelectedCountryId(selectedOption.value);
    };

    const handleStateChange = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        getCityListByStateId(selectedOption.id)
            .then((res) => {
                setSelectedStateIdFilterValue(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
        setSelectedStateId(selectedOption.value);
    };

    const handleCityChange = (e) => {
        setSelectedCityId(e.target.value);
    };

    const handleFileChange = (e) => {
        const uploadedFile = e.target.files[0];
        if (uploadedFile) {
            const cachedURL = URL.createObjectURL(uploadedFile);
            setAvatarURL(cachedURL);
        }
    };
const handleCancle=()=>{
    navigate('/mybusinessdirectory');
}
    const validateForm = () => {
        let errors = {};
        if (!companyName.trim()) {
            errors.companyName = "Business Name is required";
        }
        if (!websiteName.trim()) {
            errors.websiteName = "Business Website is required";
        }
        if (!companyEmail.trim()) {
            errors.companyEmail = "Business Email is required";
        }
        if (!companyContactName.trim()) {
            errors.companyContactName = "Contact Person is required";
        }
        if (!companyContactNumber.trim()) {
            errors.companyContactNumber = "Business Contact Number is required";
        }
        if (!companyPersonDesignaton.trim()) {
            errors.companyPersonDesignaton = "Contact Person Designation is required";
        }
        if (!selectedCategory) {
            errors.selectedCategory = "Category is required";
        }
        if (!selectedCountryId) {
            errors.selectedCountryId = "Country is required";
        }
        // if (!selectedStateId) {
        //     errors.selectedStateId = "State is required";
        // }
        // if (!selectedCityId) {
        //     errors.selectedCityId = "City is required";
        // }
        if (!comapnyDescription.trim()) {
            errors.comapnyDescription = "Business Description is required";
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0; // Return true if no errors
    };

    const handleOnlineBusinessSubmit = async (event) => {
        event.preventDefault();
        const isValid = validateForm();
        if (!isValid) {
            return;
        }

      
        const uploadedFile = fileUploadRef.current ? fileUploadRef.current.files[0] : null;
        if (uploadedFile) {
            const cachedURL = URL.createObjectURL(uploadedFile);
            setAvatarURL(cachedURL);
        }

        // Construct form data
        const formData = new FormData();
        formData.append('name', companyName);
        formData.append('link', websiteName);
        formData.append('email', companyEmail);
        formData.append('username', companyContactName);
        formData.append('phone', selectedCountryCode + " " + companyContactNumber);
        formData.append('designation', companyPersonDesignaton);
        formData.append('description', comapnyDescription);
        formData.append('categoryId', selectedCategory);
        formData.append('country', selectedCountryId);
        formData.append('state', selectedStateId);
        formData.append('city', selectedCityId);
        formData.append('alumniId', user._id);
        if (uploadedFile) {
            formData.append('image', uploadedFile);
        }

        // Log formData entries for debugging
       
        formData.forEach((value, key) => {
            console.log(`${key}: ${value}`);
        });
       
        if(
            Busnisslist &&
            ((typeof Busnisslist === "object" && !Array.isArray(Busnisslist) && Object.keys(Busnisslist).length > 0) || // Non-empty object
             (Array.isArray(Busnisslist) && Busnisslist.length > 0)) // Non-empty array
        ) {
           
        if( Busnisslist._id!=='undefined'){
           
            updateBusinessData(formData, token,Busnisslist._id)
            .then(response => {
                if(response.data.success===true){
                    handleCancle();
                }
                console.log("Business update successfully", response);
            })
            .catch(error => {
                console.error("Error creating business", error);
            });
        }
        }else{
            createBusinessData(formData, token)
            .then(response => {
                if(response.data.success===true){
                    handleCancle();
                }
                console.log("Business created successfully", response);
            })
            .catch(error => {
                console.error("Error creating business", error);
            });
        }
     
    };

    return (
        <div>
            <DashBoardLeftProfileMenu />
            <div className={'containerStyla  ' + Style.Dashboardscreen + " " + Style.BussinesList}>
                <Container>
                    <DashboardTitle title="Business Listing" membertype="Non Member" />
                    <Row className={Style.space}>
                        <Col>
                            <div className={Style.newFormStyle}>
                                <h3 className={Style.dashboardSubTitle}>ADD BUSINESS DETAILS</h3>
                                <form onSubmit={handleOnlineBusinessSubmit} id="myform" method="post" noValidate>
                                    <Row>
                                        <Col className={Style.space}>
                                            <FileUpload ref={fileUploadRef} avatarURL={avatarURL} onFileChange={handleFileChange} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={4}>
                                        
                                            <TextInput label="Business Name" id="CompanyName" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                                            {formErrors.companyName && <span className={Style.error}>{formErrors.companyName}</span>}
                                        </Col>
                                        <Col lg={4}>
                                            <TextInput label="Business Website" id="Website" value={websiteName} onChange={(e) => setWebsiteName(e.target.value)} />
                                            {formErrors.websiteName && <span className={Style.error}>{formErrors.websiteName}</span>}
                                        </Col>
                                        <Col lg={4}>
                                            <TextInput label="Business Email Id" id="BusinessEmail" value={companyEmail} onChange={(e) => setCompanyEmail(e.target.value)} />
                                            {formErrors.companyEmail && <span className={Style.error}>{formErrors.companyEmail}</span>}
                                        </Col>
                                        <Col lg={4}>
                                            <TextInput label="Contact Person" id="ContactPerson" value={companyContactName} onChange={(e) => setCompanyContactName(e.target.value)} />
                                            {formErrors.companyContactName && <span className={Style.error}>{formErrors.companyContactName}</span>}
                                        </Col>
                                        <Col lg={4}>
                                            <TextInput label="Contact Person Designation" id="Designation" value={companyPersonDesignaton} onChange={(e) => setCompanyPersonDesignaton(e.target.value)} />
                                            {formErrors.companyPersonDesignaton && <span className={Style.error}>{formErrors.companyPersonDesignaton}</span>}
                                        </Col>
                                        {getAllData && (
                                            <>
                                                <Col lg={4}>
                                                    <div className={Style.group}>
                                                        <label htmlFor="ContactNumber">Business Contact No.</label>
                                                        <div className={Style.formFlex}>
                                                            <select className={`${Style.fromControl} ${Style.CountryCode}`} id="CountryCode" name="CountryCode" value={selectedCountryCode} onChange={(e) => setSelectedCountryCode(e.target.value)}>
                                                                <option value="">Select Country Code</option>
                                                                {getAllData.countries.map((country) => (
                                                                    <option key={country.id} value={country.phone_code}>{country.phone_code}</option>
                                                                ))}
                                                            </select>
                                                            <input className={Style.fromControl} id="ContactNumber" name="ContactNumber" type="text" value={companyContactNumber} onChange={(e) => setCompanyContactNumber(e.target.value)} />
                                                            <span className={`${Style.fieldValidationValid} ${Style.textDanger}`} data-valmsg-for="ContactNumber" data-valmsg-replace="true"></span>
                                                        </div>
                                                        {formErrors.companyContactNumber && <span className={Style.error}>{formErrors.companyContactNumber}</span>}
                                                    </div>
                                                </Col>
                                                <Col lg={4}>
                                                    {getAllCategory && (
                                                        <>
                                                            <SelectInput label="Category" id="CategoryId" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} options={getAllCategory.categories} title="Select Category" />
                                                            {formErrors.selectedCategory && <span className={Style.error}>{formErrors.selectedCategory}</span>}
                                                        </>
                                                    )}
                                                </Col>
                                                <Col lg={4}>
                                                    <SelectInput label="Country" id="CountryID" value={selectedCountryId} onChange={handleCountryChange} options={getAllData.countries} title="Select Country" />
                                                    {formErrors.selectedCountryId && <span className={Style.error}>{formErrors.selectedCountryId}</span>}
                                                </Col>
                                                <Col lg={4}>
                                                    <SelectInput label="State" id="StateID" value={selectedStateId} onChange={handleStateChange} options={selectedCountryIdFilterValue} title="Select State" />
                                                    {formErrors.selectedStateId && <span className={Style.error}>{formErrors.selectedStateId}</span>}
                                                </Col>
                                                <Col lg={4}>
                                                    <SelectInput label="City" id="CityId" value={selectedCityId} onChange={handleCityChange} options={selectedStateIdFilterValue} title="Select City" />
                                                    {formErrors.selectedCityId && <span className={Style.error}>{formErrors.selectedCityId}</span>}
                                                </Col>
                                            </>
                                        )}
                                        <Col lg={4}>
                                            <TextInput label="Business Description" id="BusinessDescription" value={comapnyDescription} onChange={(e) => setComapnyDescription(e.target.value)} />
                                            {formErrors.comapnyDescription && <span className={Style.error}>{formErrors.comapnyDescription}</span>}
                                        </Col>
                                    </Row>
                                    <Row>
                                    <Col lg={12}>
                                            <div className={Style.submitBtn}>
                                                <input type="submit" name="Submit" className={Style.subBtn} value="Submit" />
                                                <a href="#" className={Style.cancelBtn} onClick={()=>handleCancle()}>Cancel</a>
                                            </div> 
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default BusinessDirectoryCreate;
